import React from 'react';
import Passage from './OnlineExamPassages';

const Section = ({ section, index, updateSection, removeSection, selectedPassageIndex, setSelectedPassageIndex, onAddPassage }) => {
    // Use the prop directly for selected passage
    const selectedIdx = typeof selectedPassageIndex === 'number' ? selectedPassageIndex : 0;
    const passages = Array.isArray(section.passages) ? section.passages : [];

    // Handle time limit change
    const handleTimeLimitChange = (e) => {
        updateSection(index, { ...section, timeLimit: e.target.value });
    };

    // Handle the per-section calculator toggle. Multi-part exams need this per part —
    // e.g. MC Part 1 has no calculator while MC Part 2 does (and the FRQ parts are reversed).
    const handleCalculatorChange = (e) => {
        updateSection(index, { ...section, calculatorEnabled: e.target.checked });
    };

    // Handle passage selection change
    const handlePassageSelectionChange = (e) => {
        setSelectedPassageIndex(Number(e.target.value));
    };

    // Update a passage
    const updatePassage = (pIndex, newPassage) => {
        const updatedPassages = passages.map((p, i) => (i === pIndex ? newPassage : p));
        updateSection(index, {
            ...section,
            passages: updatedPassages
        });
    };

    // Remove a passage
    const removePassage = (pIndex) => {
        const updatedPassages = passages.filter((_, i) => i !== pIndex);
        updateSection(index, { ...section, passages: updatedPassages });
        // If we're removing the currently selected passage, adjust the selection
        if (pIndex === selectedIdx) {
            // If we're removing the last passage, go to the previous one
            if (pIndex === passages.length - 1 && pIndex > 0) {
                setSelectedPassageIndex(pIndex - 1);
            } else {
                // Otherwise, stay at the same index (which will now be the next passage)
                setSelectedPassageIndex(Math.min(selectedIdx, updatedPassages.length - 1));
            }
        } else if (pIndex < selectedIdx) {
            // If we're removing a passage before the selected one, adjust the index
            setSelectedPassageIndex(selectedIdx - 1);
        }
    };

    return (
        <div className='border p-3 mb-4'>
            <h2>Section {index + 1}</h2>
            <label>Time Limit (Minutes):</label>
            <input
                type='number'
                className='form-control mb-2'
                value={section.timeLimit || 30}
                onChange={handleTimeLimitChange}
                min="1"
            />

            <div className='form-check mb-3'>
                <input
                    type='checkbox'
                    className='form-check-input'
                    id={`section-calc-${index}`}
                    checked={!!section.calculatorEnabled}
                    onChange={handleCalculatorChange}
                />
                <label className='form-check-label' htmlFor={`section-calc-${index}`}>
                    Allow on-screen calculator for this section
                </label>
            </div>

            {/* Passage Selection Dropdown */}
            {passages.length > 0 && (
                <select
                    value={selectedIdx}
                    onChange={handlePassageSelectionChange}
                    className='form-select mb-3'
                >
                    {passages.map((passage, pIndex) => (
                        <option key={passage.id || pIndex} value={pIndex}>
                            Passage {pIndex + 1}
                        </option>
                    ))}
                </select>
            )}

            {/* Render Only Selected Passage */}
            {passages.length > 0 && passages[selectedIdx] && (
                <Passage
                    passage={passages[selectedIdx]}
                    index={selectedIdx}
                    updatePassage={updatePassage}
                    removePassage={removePassage}
                />
            )}

            <button className='btn btn-primary mt-2' onClick={() => onAddPassage(index)}>Add Passage</button>
            <button className='btn btn-danger mt-2 ms-2' onClick={() => removeSection(index)}>Remove Section</button>
        </div>
    );
};

export default Section;